import { EventPlace, trackEngagement } from "helpers/analytics";

export const trackWorkflowCreationStarted = (location: "main" | "add", premadeType?: string): void => {
  trackEngagement("Workflows: Workflow creation started", EventPlace.Automations, { premadeType, location });
};
